import { Text } from '@connect-x-app/hybrid-ui';

import styles from './separatorWithText.module.scss';

type Props = {
  text: string;
};

export const SeparatorWithText: React.FC<Props> = ({ text }) => {
  return (
    <div className={styles['separator']}>
      <div className={styles['line']} />
      <div className={styles['textContainer']}>
        <Text className={styles['text']} size={'XS'} weight={'bold'}>
          {text}
        </Text>
      </div>
      <div className={styles['line']} />
    </div>
  );
};
